const routes = [
  {
    path: '/',
    name: 'Schedule',
    component: () => import('./pages/Schedule.vue'),
    meta: {
      title: 'Расписание',
      authorize: [],
      trained: false,
    },
  },
  {
    path: '/conference-create',
    name: 'ConferenceCreate',
    component: () => import('./pages/ConferenceCreate.vue'),
    meta: {
      title: 'Создание конференции',
      authorize: [],
      trained: false,
      breadcrumbs: {
        parent: 'Schedule',
      },
    },
  },
  {
    path: '/training',
    name: 'ScheduleEdu',
    component: () => import('./pages/Schedule.vue'),
    meta: {
      title: 'Расписание',
      authorize: [],
      trained: true,
    },
  },
];

export default routes;
